import { get } from '../api';

const getAutocompleteOptions = ({ autocompleteType, config }) =>
  get(`/${autocompleteType}/autocomplete`, config);

export default getAutocompleteOptions;
